// All browser call creation stays behind Qurve's authenticated, tenant-aware API.
export async function requestVoiceApi(baseUrl, path, { apiKey, token, method = 'GET', body, signal } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (apiKey) headers['X-API-KEY'] = apiKey;
  else if (token) headers.Authorization = `Bearer ${token}`;

  const response = await fetch(`${baseUrl.replace(/\/?$/, '/')}voice/${path}`, {
    method,
    headers,
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
    ...(signal ? { signal } : {}),
  });
  const data = await response.json();
  if (!response.ok) {
    const error = new Error(data.message || data.detail || `Voice request failed (${response.status})`);
    error.status = response.status;
    throw error;
  }
  return data;
}

export function validateVoiceConnection(data) {
  if (!data || typeof data.access_token !== 'string' || !data.access_token ||
      typeof data.call_id !== 'string' || !data.call_id || data.transport !== 'gateway' ||
      !Array.isArray(data.ice_servers) || !Number.isFinite(data.expires_at)) {
    throw new Error('Incomplete voice connection details. The backend must support Retell v3.');
  }
  if (data.expires_at <= Date.now()) {
    throw new Error('Voice connection has expired. Start a new call.');
  }
  return data;
}

export async function registerVoiceCall(baseUrl, auth, body) {
  const data = await requestVoiceApi(baseUrl, 'register_call/', { ...auth, method: 'POST', body });
  return validateVoiceConnection(data);
}

export function getVoiceCallMetadata(baseUrl, auth, callId, after, signal) {
  return requestVoiceApi(baseUrl, `calls/${encodeURIComponent(callId)}/metadata/?after=${after}`, {
    ...auth, signal,
  });
}

export function stopVoiceCall(baseUrl, auth, callId) {
  return requestVoiceApi(baseUrl, `calls/${encodeURIComponent(callId)}/stop/`, { ...auth, method: 'POST' });
}
